export class RendererFacetFactory {
    static register(facetType, renderableType) {
        if (this.registry.has(facetType.typestatic)) {
            throw new Error(`RendererFacetFactory.register: facet type ${facetType.typestatic} already registered`);
        }
        if (renderableType.facetType != undefined) {
            throw new Error(`RendererFacetFactory.register: renderable type ${renderableType} already registered`);
        }
        this.registry.set(facetType.typestatic, renderableType);
        renderableType.facetType = facetType;
    }
    static getFacetTypes() {
        return Array.from(this.registry.keys());
    }
    static create(facetType, model) {
        const type = this.registry.get(facetType);
        if (type != undefined) {
            return new type(model);
        }
        return undefined;
    }
}
RendererFacetFactory.registry = new Map();
